<div
  class="calendarEvent"
  data-testid="reminder-calendar-element"
  [class.calendarEvent--dismissed]="isDismissed"
  [class.calendarEvent--overdue]="isOverdue"
>
  <div
    class="calendarEvent__inner"
    [class.calendarEvent__inner--daily]="ppDailyView"
    (click)="openReminder($event)"
    [class.calendarEvent__inner--snoozed]="isSnoozed"
  >
    <p
      class="calendarEvent__name"
      [class.calendarEvent__name--dismissed]="isDismissed"
      [class.calendarEvent__name--overdue]="isOverdue"
      ppTooltip
      [ppTitle]="ppReminder.name"
      [ppTrimTooltip]="true"
    >
      {{ ppReminder.name }}
    </p>
    <div class="calendarEvent__dueDateContainer">
      <span class="calendarEvent__timestamp">{{ formattedTimestamp }}</span>
      @if (ppReminder.seriesId) {
        <pp-icon
          ppColor="inherit"
          [ppSrc]="EIconPath.ICON_MISC_RECURRING_ICON_12"
          ppTooltip
        ></pp-icon>
      }
      @if (createdForMe) {
        <pp-icon
          ppColor="inherit"
          ppClass="setSize12"
          [ppSrc]="EIconPath.ICON_ROUND_PEOPLE_SINGLE_12"
          ppTooltip
          [ppTitle]="'reminder_created_for_you' | ppTranslate"
        ></pp-icon>
      }
      @if (createdForOthers) {
        <pp-icon
          ppColor="inherit"
          ppClass="setSize12"
          [ppSrc]="EIconPath.ICON_ROUND_PEOPLE_12"
          ppTooltip
          [ppTitle]="'reminder_created_by_you_for_others' | ppTranslate"
        ></pp-icon>
      }
    </div>
  </div>
  <section
    class="calendarEvent__pointRef"
    [class.calendarEvent__pointRef--daily]="ppDailyView"
    (click)="openPoint()"
  >
    @if (isSnoozed) {
      <section class="reminderSnoozeSection">
        <pp-icon
          ppTooltip
          [ppTitle]="snoozedTimestamp"
          [ppSrc]="EIconPath.ICON_MISC_SNOOZE_18"
          class="reminderSnoozeIcon"
          ppClass="setSize18"
          ppColor="inherit"
        ></pp-icon>
        @if (ppDailyView) {
          <span class="reminderSnoozeTimestamp">{{ snoozedTimestamp }}</span>
        }
      </section>
    }
    @if (ppDailyView && ppReminder.pointId) {
      <pp-reminder-point-reference
        [ppReminder]="ppReminder"
        [ppBrightMode]="true"
      ></pp-reminder-point-reference>
    }
    @if (!ppDailyView && ppReminder.pointId) {
      <div
        (click)="openPoint()"
        [ppInteractive]="true"
        [ppOptions]="tooltipOptions"
        ppTooltip
        [ppTitle]="pointTooltip"
        [ppSanitize]="false"
        class="calendarEvent__priority"
        [class.calendarEvent__priority--LOW]="ppReminder.pointPriority === EPriority.LOW"
        [class.calendarEvent__priority--MEDIUM]="ppReminder.pointPriority === EPriority.MEDIUM"
        [class.calendarEvent__priority--HIGH]="ppReminder.pointPriority === EPriority.HIGH"
      ></div>
    }
  </section>
</div>
